export default __webpack_public_path__ + "images/faceIdFailedV2.v-5cbdb56fed880b6a516644d136e7ae44.svg";